import { HOST, registerModel } from '@/utils/base';

export default [
    // 共通 - 主页
    {
        path: HOST,
        component: () => import('@/routes/common/index'),
        beforeEnter: (to, from, next) => {
            next();
        },
    },
    // 共通 - 登录
    {
        name: 'login',
        path: HOST + 'login',
        component: () => import('@/routes/common/login'),
        beforeEnter: (to, from, next) => {
            // document.title = '联扩供应链系统'
            // registerModel('home', require('@/store/modules/home').default)
            next();
        },
    },
    // 系统首页
    {
        path: HOST + 'home',
        component: () => import('@/routes/common/home'),
        beforeEnter: (to, from, next) => {
            // document.title = '联扩供应链系统'
            // registerModel('home', require('@/store/modules/home').default)
            next();
        },
    },
    // 系统设置
    {
        path: HOST + 'system',
        component: () => import('@/layouts/ImsLayout'),
        beforeEnter: (to, from, next) => {
            // document.title = '联扩供应链系统'
            // registerModel('home', require('@/store/modules/home').default)
            next();
        },
        children: [
            {
                // 新增审批流
                path: 'approval/add',
                component: () => import('@/routes/system/approval/add'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 审批流编辑
                path: 'approval/edit',
                component: () => import('@/routes/system/approval/edit'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                //  审批流列表
                path: 'approval/list',
                component: () => import('@/routes/system/approval/list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 业务审批配置
                path: 'approval/tradetype_list',
                component: () => import('@/routes/system/approval/tradetype_list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 基础配置管理
                path: 'config/config_list',
                component: () => import('@/routes/system/config/config_list'),
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                // 组织结构设置 - 部门管理(树形结构)
                path: 'organization/department',
                component: () => import('@/routes/system/organization/department_tree'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },

            {
                // 组织结构设置 - 职员管理
                path: 'organization/user',
                component: () => import('@/routes/system/organization/user_list'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },
            {
                // 组织结构设置 - 岗位管理
                path: 'organization/position',
                component: () => import('@/routes/system/organization/position_list'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },
            {
                // 权限配置管理
                path: 'permission',
                component: () => import('@/routes/system/permission/index'),
                beforeEnter: (to, from, next) => {
                    // document.title = '联扩供应链系统'
                    // registerModel('home', require('@/store/modules/home').default)
                    next();
                },
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/common/frame_router.js